module.exports = __webpack_public_path__ + "img/Arrow-Down.490d06ff.svg";